import { render } from "./Headline.vue?vue&type=template&id=abfb3f30&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=js"
export * from "./Headline.vue?vue&type=script&lang=js"

import "./Headline.vue?vue&type=style&index=0&id=abfb3f30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abfb3f30"]])

export default __exports__